// extracted by mini-css-extract-plugin
module.exports = {"footerBg":"E-z","footerTopLinks":"F-z","footerFeedback":"G-z","footerSocial":"H-z","footerLegalLinks":"I-z","footerIconCards":"J-z","footerBotCopy":"K-z","screenReadersOnly":"L-z"};